import { gql } from '@apollo/client';

const commonCompanyFragment = gql`
  fragment CommonCompanyFragment on Company {
    id
    name
    representative
    foundedOn
    employeesNumber
    headquartersAddress
    prefecture
    offices
    logo
    coverImage
    homepage
    industry
    businessDescription
    corporatePhilosophy
  }
`;

const commonJobFragment = gql`
  ${commonCompanyFragment}

  fragment CommonJobFragment on Job {
    id
    title
    description
    company {
      ...CommonCompanyFragment
    }
    coverImage
    images
    members {
      name
      image
    }
    idealCandidate
  }
`;

const showJob = gql`
  ${commonJobFragment}

  query ShowJob($id: ID!) {
    job(id: $id) {
      ...CommonJobFragment
      liked
      accepted
      characteristicLabels {
        id
        name
      }
    }
  }
`;

const listJobs = gql`
  ${commonJobFragment}

  query ListJobs($pagination: PaginationInput) {
    jobs(pagination: $pagination) {
      data {
        ...CommonJobFragment
      }
      pagination {
        total
      }
    }
  }
`;

const likeJob = gql`
  mutation LikeJob($id: String!) {
    likeJob(id: $id) {
      liked
      accepted
    }
  }
`;

const jobLikes = gql`
  query JobLikes {
    jobLikes {
      data {
        accepted
        direction
        job {
          id
          title
          company {
            name
          }
        }
      }
    }
  }
`;

const showCompany = gql`
  ${commonCompanyFragment}
  ${commonJobFragment}

  query ShowCompany($id: ID!) {
    company(id: $id) {
      ...CommonCompanyFragment
      jobs {
        ...CommonJobFragment
      }
    }
  }
`;

export { likeJob, jobLikes, listJobs, showJob, showCompany };
